import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nieuw product',
  fields: {
    type: {
      label: 'Producttype',
      options: {
        [SubscriptionProductType.Plan]: 'Plan',
        [SubscriptionProductType.AddOn]: 'Add-on',
        [SubscriptionProductType.GoogleAdsPlan]: 'Google Ads Plan',
      },
    },
    name: {
      label: 'Interne naam',
      placeholder: 'Voer interne productnaam in',
    },
    public_name: {
      label: 'Publieke naam',
      placeholder: 'Voer publieke productnaam in',
    },
    description: {
      label: 'Omschrijving',
    },
  },
  buttons: {
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  feedback: {
    missing_info: 'Ontbrekende informatie',
  },
  toasts: {
    plan_got_created: 'Product aangemaakt',
    plan_got_updated: 'Product bijgewerkt',
  },
};
